/* Royal Pcs theme — language, header, cart drawer, product form */
(function () {
  var cfg = window.RP_CFG || {};
  var WA = cfg.whatsapp || '97450987214';

  // ---------------- language ----------------
  var T = {
    en: {
      shop: 'Shop', worlds: 'The Worlds', story: 'Our Story', visit: 'Visit Us', home: 'Home',
      bag: 'Your bag', bagEmpty: 'Your bag is empty — the little friends are waiting in the shop.',
      subtotal: 'Subtotal', checkout: 'Checkout', continue: 'Continue shopping',
      deliveryNote: 'Delivery to Qatar, the GCC and worldwide is calculated at checkout. Outside Qatar, local VAT or customs charges may be collected on delivery.',
      busy: 'The shop is busy for a moment. Please try again.',
      stockMax: 'All the pieces we have in this size are already in your bag.', soldOutNow: 'Sorry, this piece has just sold out.',
      added: 'Added to your bag', remove: 'Remove', qar: 'QAR', sold: 'Sold out', sale: 'Sale', from: 'From',
      addToBag: 'Add to bag', soldOut: 'Sold out', choose: 'Please choose', error: 'Something went wrong — please try again.',
      axEmbErr: 'Please write the name to embroider.', axLetters: 'Please use letters only. We can’t print emoji or symbols.',
      sunWed: 'Sun – Wed', thu: 'Thursday', fri: 'Friday', sat: 'Saturday',
      boutique: 'Galeries Lafayette Doha · Blue Salon, Doha Festival City · Blue Salon, The Pearl', ipNote: 'All Royal Pcs Royal Family characters are protected by intellectual property rights.',
      ftrAbout: 'Children’s clothing, gifts and keepsakes for little ones from 3 months to 10 years — wrapped in softness, comfort and timeless charm.',
      ftrShop: 'Shop', ftrHouse: 'The House', ftrVisit: 'Find us in Doha', ftrHelp: 'Help',
      rights: '© 2026 Royal Pcs. All rights reserved.', since: 'Qatar · Since 2020',
      // spend-more offer: only the tier the bag has reached is ever shown (offerHave = shop busy fallback only)
      offerOn: '{c} applied: {p}% off. You save {x}.', offerBest: 'That’s our biggest discount.',
      offerUp: 'Add {x} more to unlock {p}% off.', offerNext: 'Add {x} more to get {p}% off.', offerAuto: 'We add the code for you.',
      offerHave: '{p}% off unlocked! Code {c} is applied at checkout.', offerOther: '{c} applied. You save {x}.',
      youSave: 'You save', offPill: '−{p}%', discBusy: 'Updating your discount…',
      offerMystery: 'Mystery Box and Mystery Set stay at full price and don’t count toward the 500 / 1,000 / 1,500 QAR total.',
      // offerExclVal is the line property sent to checkout and the order (both languages); exclLine is what the bag shows
      offerExclKey: 'Discount', offerExclVal: 'Not included. Mystery items are always full price. | غير مشمول. منتجات المفاجآت دائماً بسعرها الكامل.',
      exclLine: 'Discount: not included (full price)',
      // country & currency picker
      cxTitle: 'Where are you shopping from?',
      cxSub: 'Choose your country to see prices in your currency. You can change it any time from the flag at the top.',
      cxOther: 'Other countries', cxSearch: 'Search for your country', cxNone: 'No matching country', cxBack: 'Back',
      cxPay: 'You always pay in Qatari riyals (QAR). Prices in other currencies are a guide.',
      cxSaving: 'Updating your country…', cxSuggested: 'Suggested', cxRow: 'Country & currency', cxChange: 'Change',
      cxCoCheck: 'Already been to checkout? Please check the delivery country there too.', cxLoading: 'Loading the list…'
    },
    ar: {
      shop: 'المتجر', worlds: 'العوالم', story: 'قصتنا', visit: 'زورونا', home: 'الرئيسية',
      bag: 'حقيبتك', bagEmpty: 'حقيبتك فارغة — الأصدقاء الصغار بانتظارك في المتجر.',
      subtotal: 'المجموع', checkout: 'إتمام الطلب', continue: 'متابعة التسوق',
      deliveryNote: 'تُحسب رسوم التوصيل داخل قطر ودول الخليج وإلى جميع أنحاء العالم عند إتمام الطلب. خارج قطر قد تُحصَّل ضريبة القيمة المضافة أو الرسوم الجمركية المحلية عند الاستلام.',
      busy: 'المتجر مشغول للحظة. يرجى المحاولة مرة أخرى.',
      stockMax: 'الكمية المتوفرة من هذه القطعة موجودة كلها في حقيبتكم.', soldOutNow: 'عذراً، نفدت هذه القطعة للتو.',
      added: 'أُضيف إلى حقيبتك', remove: 'إزالة', qar: 'ر.ق', sold: 'نفدت الكمية', sale: 'تخفيض', from: 'من',
      addToBag: 'أضف إلى الحقيبة', soldOut: 'نفدت الكمية', choose: 'يرجى الاختيار', error: 'حدث خطأ — حاول مرة أخرى.',
      axEmbErr: 'يرجى كتابة الاسم المطلوب تطريزه.', axLetters: 'يرجى كتابة الاسم بالحروف فقط، فلا يمكننا طباعة الرموز التعبيرية أو الرموز الخاصة.',
      sunWed: 'الأحد – الأربعاء', thu: 'الخميس', fri: 'الجمعة', sat: 'السبت',
      boutique: 'غاليري لافاييت الدوحة · بلو صالون، دوحة فستيفال سيتي · بلو صالون، اللؤلؤة', ipNote: 'جميع شخصيات عائلة رويال بيسز محمية بحقوق الملكية الفكرية',
      ftrAbout: 'ملابس وهدايا وتذكارات للأطفال من عمر ٣ أشهر حتى ١٠ سنوات — بكل نعومة وراحة وسحر لا يزول.',
      ftrShop: 'المتجر', ftrHouse: 'الدار', ftrVisit: 'تجدوننا في الدوحة', ftrHelp: 'مساعدة',
      rights: '© 2026 رويال بيسز. جميع الحقوق محفوظة.', since: 'قطر · منذ 2020',
      offerOn: 'تم تطبيق الكود {c}: خصم {p}%. وفّرتم {x}.', offerBest: 'هذا أكبر خصم لدينا.',
      offerUp: 'أضيفوا {x} ليرتفع خصمكم إلى {p}%.', offerNext: 'أضيفوا {x} لتحصلوا على خصم {p}%.', offerAuto: 'نضيف الكود لكم تلقائياً.',
      offerHave: 'حصلتم على خصم {p}%! يُطبَّق الكود {c} عند إتمام الطلب.', offerOther: 'تم تطبيق الكود {c}. وفّرتم {x}.',
      youSave: 'وفّرتم', offPill: 'خصم {p}%', discBusy: 'جارٍ تحديث الخصم…',
      offerMystery: 'علبة المفاجآت ومجموعة المفاجآت بسعرهما الكامل دائماً، ولا تُحتسبان ضمن مجموع ٥٠٠ / ١٠٠٠ / ١٥٠٠ ر.ق.',
      offerExclKey: 'Discount', offerExclVal: 'Not included. Mystery items are always full price. | غير مشمول. منتجات المفاجآت دائماً بسعرها الكامل.',
      exclLine: 'الخصم: غير مشمول (بالسعر الكامل)',
      cxTitle: 'من أين تتسوّقون؟',
      cxSub: 'اختاروا دولتكم لتظهر الأسعار بعملتكم، ويمكنكم تغييرها في أي وقت من العَلَم أعلى الصفحة.',
      cxOther: 'دول أخرى', cxSearch: 'ابحثوا عن دولتكم', cxNone: 'لم نجد دولة بهذا الاسم', cxBack: 'رجوع',
      cxPay: 'الدفع دائماً بالريال القطري (ر.ق)، والأسعار بالعملات الأخرى تقريبية للاسترشاد.',
      cxSaving: 'جارٍ تحديث الدولة…', cxSuggested: 'مقترحة', cxRow: 'الدولة والعملة', cxChange: 'تغيير',
      cxCoCheck: 'هل فتحتم صفحة إتمام الطلب من قبل؟ تأكدوا من دولة التوصيل هناك أيضاً.', cxLoading: 'جارٍ تحميل القائمة…'
    }
  };
  // Arabic is a Shopify language (/ar/...) when published: the URL decides, so checkout and emails follow.
  // Without it, fall back to the in-page switch remembered in localStorage.
  var shopAr = (window.RP_LOCALES || []).indexOf('ar') > -1;
  // cart requests go through the locale root (/ar/) so titles and sizes come back in the shopper's language
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lang = 'en';
  if (shopAr) {
    lang = window.RP_LOCALE === 'ar' ? 'ar' : 'en';
  } else {
    try { lang = localStorage.getItem('rp-lang') || 'en'; } catch (e) {}
    if (/[?&]lang=ar/.test(location.search)) lang = 'ar';
    if (/[?&]lang=en/.test(location.search)) lang = 'en';
  }
  var SKIP = /^\/(ar(\/|$)|cdn\/|checkout|checkouts\/|services\/|tools\/|apps\/|account\/logout)/;
  function localiseLinks(root) {
    if (!shopAr || lang !== 'ar') return;
    (root || document).querySelectorAll('a[href^="/"]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (h.charAt(1) === '/' || SKIP.test(h)) return;
      a.setAttribute('href', '/ar' + (h === '/' ? '' : h));
    });
  }
  // links added later by other scripts (storybook hero, worlds) are fixed at click time
  document.addEventListener('click', function (e) {
    if (!shopAr || lang !== 'ar') return;
    var a = e.target.closest && e.target.closest('a[href^="/"]');
    if (!a) return;
    var h = a.getAttribute('href');
    if (h.charAt(1) !== '/' && !SKIP.test(h)) a.setAttribute('href', '/ar' + (h === '/' ? '' : h));
  }, true);
  var ARIA_AR = { 'Bag': 'الحقيبة', 'Breadcrumb': 'مسار التنقل', 'Character worlds': 'عوالم الشخصيات', 'Characters': 'الشخصيات', 'Close bag': 'إغلاق الحقيبة',
    'Close menu': 'إغلاق القائمة', 'Collections': 'التشكيلات', 'Main': 'القائمة الرئيسية', 'Mobile': 'القائمة', 'Open bag': 'فتح الحقيبة', 'Open menu': 'فتح القائمة',
    'Pages': 'الصفحات', 'Remove': 'إزالة', 'Royal Pcs on Instagram': 'رويال بيسز على إنستغرام', 'Search': 'بحث', 'Switch language': 'تغيير اللغة',
    'The Royal Pcs colours': 'ألوان رويال بيسز', 'The Royal Pcs storybook': 'حكاية رويال بيسز', 'WhatsApp': 'واتساب', 'Decrease': 'إنقاص', 'Increase': 'زيادة',
    'Royal Pcs — home': 'رويال بيسز — الرئيسية', 'Close': 'إغلاق', 'Change country and currency': 'تغيير الدولة والعملة' };
  var PROP_AR = { 'For': 'لـ', 'Message': 'الرسالة', 'Name': 'الاسم', 'Size': 'المقاس', 'Discount': 'الخصم', 'With': 'مع', 'Note': 'ملاحظة',
    // free gift card (rp-gift.js): the keys stay in English on the order for the team; the bag shows them in Arabic
    'Gift card': 'بطاقة الهدية', 'Card to': 'إلى', 'Card message': 'رسالة البطاقة', 'Card from': 'من', 'Hide prices': 'إخفاء الأسعار', 'Recipient phone': 'هاتف المستلم',
    // a name saved on an add-on's own line (the 3-layer box, Name embroidery): see the product form below
    'Name on box': 'الاسم على العلبة', 'Name to embroider': 'الاسم للتطريز' };
  var VAL_AR = { 'Yes': 'نعم' };
  function propVal(k, v) { return lang === 'ar' && VAL_AR[v] ? VAL_AR[v] : v; }
  // a short signature (same words, same value): the add-on names in short on the piece (_rp_ax, see Add to bag)
  function sig(s) { var h = 5381; s = String(s); for (var i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0; return (h >>> 0).toString(36); }
  function t(k) { return (T[lang] && T[lang][k]) || T.en[k] || k; }
  function applyLang(root) {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    (root || document).querySelectorAll('[data-en]').forEach(function (el) {
      var v = el.getAttribute('data-' + lang) || el.getAttribute('data-en');
      if (el.hasAttribute('data-html')) el.innerHTML = v; else el.textContent = v;
    });
    (root || document).querySelectorAll('[data-t]').forEach(function (el) { el.textContent = t(el.getAttribute('data-t')); });
    (root || document).querySelectorAll('[data-ph-en]').forEach(function (el) { el.placeholder = el.getAttribute('data-ph-' + lang) || el.getAttribute('data-ph-en'); });
    var lb = document.getElementById('langBtn'); if (lb) lb.textContent = lang === 'ar' ? 'EN' : 'العربية';
    (root || document).querySelectorAll('[aria-label]').forEach(function (el) {
      var en = el.getAttribute('data-aria-en') || el.getAttribute('aria-label'); el.setAttribute('data-aria-en', en);
      var m = /^Photo (\d+)$/.exec(en), ar = el.getAttribute('data-aria-ar');
      el.setAttribute('aria-label', lang === 'ar' ? (ar || (m ? 'صورة ' + m[1] : (ARIA_AR[en] || en))) : en);
    });
    (root || document).querySelectorAll('[data-alt-ar]').forEach(function (el) { if (!el.hasAttribute('data-alt-en')) el.setAttribute('data-alt-en', el.alt); el.alt = lang === 'ar' ? el.getAttribute('data-alt-ar') : el.getAttribute('data-alt-en'); });
    (root || document).querySelectorAll('[data-title-ar]').forEach(function (el) { if (!el.hasAttribute('data-title-en')) el.setAttribute('data-title-en', el.title); el.title = lang === 'ar' ? el.getAttribute('data-title-ar') : el.getAttribute('data-title-en'); });
    var skip = document.querySelector('a.sr[href="#MainContent"]'); if (skip) skip.textContent = lang === 'ar' ? 'تخطَّ إلى المحتوى' : 'Skip to content';
    localiseLinks(root);
  }
  function setLang(l) {
    try { localStorage.setItem('rp-lang', l); } catch (e) {}
    if (shopAr) {
      var p = location.pathname.replace(/^\/ar(?=\/|$)/, '') || '/';
      // the page reloads in the other language: a gift card being written (rp-gift.js) is kept for that one reload
      try { document.dispatchEvent(new CustomEvent('rp:leave')); } catch (e) {}
      location.href = (l === 'ar' ? '/ar' + (p === '/' ? '' : p) : p) + location.search.replace(/[?&]lang=(ar|en)/, '') + location.hash;
      return;
    }
    lang = l;
    applyLang(); renderCart(); document.dispatchEvent(new CustomEvent('rp:lang'));
  }

  function moneyQ(cents) {   // always QAR = what the customer is charged
    var v = Math.round(cents) / 100;
    var s = v % 1 === 0 ? v.toLocaleString('en-US') : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return s + ' ' + t('qar');
  }
  function money(cents) {    // the currency the visitor picked (QAR when none); display only
    return window.RPX && RPX.cur !== 'QAR' ? RPX.text(cents) : moneyQ(cents);
  }
  // a saving: before - after, from the two rounded converted amounts, so the three figures on screen add up
  function moneyLess(a, b) {
    if (!window.RPX || RPX.cur === 'QAR') return moneyQ(a - b);
    return RPX.textLess ? RPX.textLess(a, b) : RPX.text(a - b);   // older rp-cx-head: plain conversion
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // ---------------- header ----------------
  var hdr = document.querySelector('.hdr');
  var page = document.body.getAttribute('data-page') || '';
  if (hdr && page === 'home') {
    var onS = function () { hdr.classList.toggle('solid', window.scrollY > (window.RP_HERO_END ? window.RP_HERO_END() : 80)); };
    window.addEventListener('scroll', onS, { passive: true }); onS();
  }
  var mnav = document.getElementById('mnav');
  var on = function (id, ev, fn) { var el = document.getElementById(id); if (el) el.addEventListener(ev, fn); };
  on('menuBtn', 'click', function () { mnav.classList.add('open'); });
  on('menuClose', 'click', function () { mnav.classList.remove('open'); });
  on('langBtn', 'click', function () { setLang(lang === 'ar' ? 'en' : 'ar'); });

  // ---------------- cart drawer ----------------
  var drawer = document.getElementById('cartDrawer'), scrim = document.getElementById('cartScrim');
  var toast = document.getElementById('toast');
  var OFFER = cfg.offer === true;   // Theme settings > Spend-more offer (off unless the owner ticks it)
  var cart = null, cartAt = 0, cartGen = -1;
  var BACK_ARROW = '<svg class="arrow back" width="18" height="12" viewBox="0 0 18 12" aria-hidden="true"><path d="M1 6h15M11 1l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  // force: read the bag again even if a read is already running (after Add to bag)
  function openCart(force) { if (!drawer) return; scrim.classList.add('open'); drawer.classList.add('open'); refreshCart(force === true); }
  function closeCart() { if (!drawer) return; scrim.classList.remove('open'); drawer.classList.remove('open'); }
  on('bagBtn', 'click', function (e) { if (drawer) { e.preventDefault(); openCart(); } });
  on('bagClose', 'click', closeCart);
  // "Continue shopping" in the bag: close it and stay on this page. One listener, because the footer is rebuilt on every render.
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-rp-continue]'); if (b) { e.preventDefault(); closeCart(); } });
  if (scrim) scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { var de = document.documentElement; if (e.key === 'Escape' && !de.classList.contains('cx-open') && !de.classList.contains('gc-open')) { closeCart(); if (mnav) mnav.classList.remove('open'); } });
  function onCartPage() { return !!document.querySelector('.cart-page form'); }

  // while the shop answers: dim the bag, block double taps, tell screen readers.
  // Counted, so one request finishing can't clear the busy state of another one still running.
  var busyN = 0;
  function setBusy(b) { busyN = Math.max(0, busyN + (b ? 1 : -1)); paintBusy(); }
  function paintBusy() {
    var b = busyN > 0;
    if (drawer) drawer.classList.toggle('is-busy', b);
    var f = document.getElementById('bagScroll'); if (f) { if (b) f.setAttribute('aria-busy', 'true'); else f.removeAttribute('aria-busy'); }
    document.querySelectorAll('[data-l]').forEach(function (x) { x.disabled = b; });
    var st = document.getElementById('bagBusy');
    if (!st && drawer) { st = document.createElement('p'); st.id = 'bagBusy'; st.className = 'sr'; st.setAttribute('role', 'status'); drawer.appendChild(st); }
    if (st) st.textContent = b && drawer.classList.contains('open') ? t('discBusy') : '';
  }

  // ---- cart requests: ONE queue for reads and writes, so a read never overtakes a write ----
  // gen goes up with every write. A cart object remembers the gen it reflects (_rpGen): when gen has moved on,
  // that cart is out of date (e.g. Add to bag while the page-load read was still running).
  // A successful answer comes back as text/javascript, so read the text and parse it.
  // 429 (bot challenge), 422 or anything that is not a cart counts as "busy".
  // wgen counts only the shopper's own writes (not the code fixes made while reading), to decide if a running read is still good.
  var cartQ = Promise.resolve(), gen = 0, wgen = 0;
  // a request that never answers (lost network) must not block the queue: the next one starts after 15 s at most
  function queued(run) {
    var p = cartQ.then(run, run);
    cartQ = Promise.race([p.catch(noop), new Promise(function (res) { setTimeout(res, 15000); })]);
    return p;
  }
  function readCart(r) {
    return r.text().then(function (s) { var j = null; try { j = JSON.parse(s); } catch (e) {} if (!r.ok || !j || !j.items) throw { status: r.status, busy: r.status === 429 || !j, description: j && (j.description || j.message) }; return j; });
  }
  // On the Arabic site Shopify answers a cart WRITE (update.js with a change or a code, change.js) with the ENGLISH
  // titles and sizes, even through /ar/; only cart.js reads come back in Arabic. So on Arabic the bag is read again
  // straight after the write, in the same queue slot, before anything is drawn from it (the drawer showed
  // "Lino Gift Set / 3 Months" after a ROYAL code change or + / −). If that read fails, the write's own answer is used.
  function cartPost(path, body, isSync) {
    var my = ++gen; if (!isSync) wgen++;
    return queued(function () {
      return fetch(ROOT + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(readCart).then(function (j) {
          j._rpGen = my;
          if (!(shopAr && lang === 'ar' && j.items.length)) return j;
          return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
            .then(readCart).then(function (k) { k._rpGen = my; return k; }, function () { return j; });
        });
    });
  }
  function cartGet() {
    var my = gen;
    return queued(function () {
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(readCart).then(function (j) { j._rpGen = my; return j; });
    });
  }
  // Add to bag: same queue; keeps Shopify's own error text (e.g. "only 2 left"). Shopify sends its 422 (not enough
  // stock) as text/javascript, so the answer is read as text whatever its type: "busy" only for 429 or no JSON.
  function cartAdd(items) {
    ++gen; wgen++;
    return queued(function () {
      return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) {
          return r.text().then(function (s) {
            var j = null; try { j = JSON.parse(s); } catch (e) {}
            if (r.status === 429 || !j) throw { busy: true, status: r.status };
            if (!r.ok) { j.status = r.status; throw j; }
            return j;
          });
        });
    });
  }
  // what to tell the shopper when the shop said no (Shopify's words in English; ours in Arabic when its words aren't)
  function cartErr(x) {
    if (!x) return t('error');
    if (x.busy) return t('busy');
    var d = String(x.description || x.message || '');
    if (!d) return t('error');
    if (lang === 'ar' && !/[\u0600-\u06FF]/.test(d)) return /sold out|unavailable/i.test(d) ? t('soldOutNow') : (x.status === 422 ? t('stockMax') : t('error'));
    return d;
  }
  function useCart(c) { cart = c; cartAt = Date.now(); cartGen = c && c._rpGen != null ? c._rpGen : gen; }
  function cartFresh() { return !!cart && cartGen === gen; }

  // One cart.js read at a time: page load, bag open, retry and Back from checkout share it (150 ms window).
  // A caller gets the running read only if no write happened since it was sent; otherwise (or with force)
  // a new read is chained after it. Only the newest read draws the bag.
  // The tier code is fixed first (settle), then everything is drawn from what Shopify answered.
  var refreshing = null, refreshSent = null, refreshSeq = 0;
  function refreshCart(force) {
    if (refreshing && !force && (refreshSent === null || refreshSent === wgen)) return refreshing;
    var mySeq = ++refreshSeq, prev = refreshing;
    var p = (prev ? prev.then(noop, noop) : Promise.resolve()).then(function () { return doRefresh(mySeq); });
    refreshing = p;
    p.then(function () { if (refreshing === p) refreshing = null; });
    return p;
  }
  function noop() {}
  function doRefresh(mySeq) {
    refreshSent = null;
    setBusy(true);                                  // straight away: no taps on old buttons during the 150 ms wait
    return new Promise(function (res) { setTimeout(res, 150); })
      .then(function () { refreshSent = wgen; return cartGet(); })
      .then(function (c) {
        return settle(c).then(function (n) {
          useCart(n);
          if (mySeq !== refreshSeq) return n;       // a newer read is on its way: let it draw
          // the bag page is drawn by the server and its line keys change with the code: reload it once
          if (n._rpCodeChanged && onCartPage() && reloadCartPage()) return n;
          renderCart(); return n;
        });
      })
      .catch(function () { var body = document.getElementById('bagBody'); if (body && !cart) body.innerHTML = '<p class="empty">' + t('busy') + ' <button type="button" class="btn ghost" id="bagRetry">↻</button></p>'; var rb = document.getElementById('bagRetry'); if (rb) rb.onclick = function () { refreshCart(true); }; })
      .then(function (x) { setBusy(false); return x; });
  }
  // never reload the bag page twice within 8 s (sessionStorage, with a short cookie when storage is blocked)
  function reloadCartPage() {
    var last = 0;
    try { last = +sessionStorage.getItem('rp-code-reload') || 0; } catch (e) {}
    var m = /(?:^|;\s*)rp_code_reload=(\d+)/.exec(document.cookie || ''); if (m) last = Math.max(last, +m[1]);
    if (Date.now() - last < 8000) return false;
    try { sessionStorage.setItem('rp-code-reload', String(Date.now())); } catch (e) {}
    try { document.cookie = 'rp_code_reload=' + Date.now() + '; path=/; max-age=20; SameSite=Lax'; } catch (e) {}
    location.reload();
    return true;
  }
  // Back from checkout (page restored from the browser cache, e.g. Instagram's in-app browser): read the bag again
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-rp-checkout][aria-disabled]').forEach(function (a) { a.removeAttribute('aria-disabled'); });
    document.querySelectorAll('.cart-page form [type=submit]').forEach(function (b) { b.disabled = false; });
    busyN = 0; paintBusy();
    cartGen = -1;                                   // checkout may have changed the bag: don't trust the old copy
    cartQ = Promise.resolve(); refreshing = null;   // requests cut off when the page was frozen will never answer
    refreshCart(true);
  });
  // gift box & other add-ons are Shopify nested lines (parent_relationship); older carts used _rp_key/_rp_parent
  function parentIn(c, it) {
    if (it.parent_relationship && it.parent_relationship.parent_key) return c.items.filter(function (x) { return x.key === it.parent_relationship.parent_key; })[0] || null;
    if (it.properties && it.properties._rp_parent) return c.items.filter(function (x) { return x.properties && x.properties._rp_key === it.properties._rp_parent; })[0] || null;
    return null;
  }
  function parentOf(it) { return parentIn(cart, it); }
  function isChild(it) { return !!((it.parent_relationship && it.parent_relationship.parent_key) || (it.properties && it.properties._rp_parent)); }
  // a piece's add-on lines, by add-on (variant), as positions in c.items. A piece normally has ONE line per add-on.
  // Two only happen when Shopify merged two copies of a piece (e.g. Edit card made a card the same as another
  // line's): the pieces become one line, but their gift boxes stay two lines under it.
  function addonGroups(c, parent) {
    var g = {};
    c.items.forEach(function (x, i) { if (isChild(x) && parentIn(c, x) === parent) (g[x.variant_id] = g[x.variant_id] || []).push(i); });
    return Object.keys(g).map(function (k) { return g[k]; });
  }
  // quantity and tier code change in ONE request, so the old prices never flash; settle then checks the result
  // Sent as a list in the bag's own order, not by line key: two gift boxes under two different cards of the same
  // piece can share one key, and a change by key would land on the first of them (the other piece's box).
  // Each add-on is counted per piece, whatever the number of lines: never more gift boxes than pieces. Extra lines
  // of the same add-on are folded into the first (this also repairs a bag that was merged before this fix).
  function setQty(item, q) {
    var ups = cart.items.map(function (x) { return x.quantity; });
    ups[cart.items.indexOf(item)] = q;
    addonGroups(cart, item).forEach(function (g) {
      var tot = 0; g.forEach(function (i) { tot += cart.items[i].quantity; });
      var want = tot >= item.quantity ? q : Math.min(tot, q);
      g.forEach(function (i, j) { ups[i] = j ? 0 : want; });
    });
    return cartPost('cart/update.js', withCode(cart, ups, { updates: ups })).then(settle);
  }
  // after Edit card / Remove card: if Shopify merged the edited piece into another line of the same piece, its
  // add-on lines are folded into one per add-on, at most the piece's quantity (no paid gift box without its piece)
  function foldAddons(c) {
    var ups = c.items.map(function (x) { return x.quantity; }), n = 0;
    c.items.forEach(function (par) {
      if (isChild(par)) return;
      addonGroups(c, par).forEach(function (g) {
        if (g.length < 2) return;
        var tot = 0; g.forEach(function (i) { tot += c.items[i].quantity; });
        g.forEach(function (i, j) { ups[i] = j ? 0 : Math.min(tot, par.quantity); }); n++;
      });
    });
    return n ? cartPost('cart/update.js', withCode(c, ups, { updates: ups })) : c;
  }
  // an add-on's "For" shows the parent's current (translated) name, not the name saved when it was added
  function forTitle(it) {
    var p = parentOf(it);
    return p ? p.product_title : (it.properties && it.properties.For) || '';
  }
  function orphans(c) {
    var keys = {}; c.items.forEach(function (x) { if (x.properties && x.properties._rp_key) keys[x.properties._rp_key] = 1; });
    return c.items.filter(function (x) { return x.properties && x.properties._rp_parent && !keys[x.properties._rp_parent]; });
  }

  // ---------------- bag totals ----------------
  // Always worked out from the lines. Never use total_price: once a cart has been to checkout, Shopify's
  // /cart/update.js answer includes the delivery charge checkout worked out, and the bag would show more than
  // the items cost. ROYAL codes are line discounts, so the sum of the lines is the bag total; a cart-level code
  // (a shopper's own) is taken off as well.
  function totals(c) {
    var orig = 0, lines = 0, cl = 0;
    c.items.forEach(function (it) { lines += +it.final_line_price || 0; orig += it.original_line_price != null ? +it.original_line_price : (+it.final_line_price || 0); });
    (c.cart_level_discount_applications || []).forEach(function (d) { cl += +d.total_allocated_amount || 0; });
    var now = Math.max(0, lines - cl);
    return { orig: orig, now: now, saved: Math.max(0, orig - now) };
  }

  // ---------------- spend-more offer: ROYAL30 / ROYAL40 / ROYAL50 ----------------
  // Rule: the cart always holds EXACTLY ONE tier code, the highest tier the eligible ORIGINAL total has reached
  // (Mystery items never count; gift-box child lines do), or no tier code below 500 QAR. It is set with
  // cart/update.js {discount: CODE}, which replaces the cart's whole code list ({discount: ''} clears it).
  // Every message and every price is then read from Shopify's answer, so the bag, the bag page and checkout agree.
  // Theme settings > Spend-more offer turns all of this off (no codes added, no offer messages).
  var TIERS = [{ min: 50000, p: 30, c: 'ROYAL30' }, { min: 100000, p: 40, c: 'ROYAL40' }, { min: 150000, p: 50, c: 'ROYAL50' }];
  var TIER_RE = /^ROYAL(30|40|50)$/i;
  function isMystery(it) { return /mystery|surprise|مفاج/i.test((it.product_type || '') + ' ' + (it.product_title || '')); }
  function fill(k, o) { return t(k).replace(/\{(\w)\}/g, function (m, n) { return o[n]; }); }
  function tierByCode(code) { code = String(code || '').toUpperCase(); return TIERS.filter(function (x) { return x.c === code; })[0] || null; }
  // eligible total BEFORE any code; qty = optional {lineKey: newQty}, or a list in the bag's order, to predict the total after a change
  function eligibleSum(c, qty) {
    var s = 0;
    c.items.forEach(function (it, i) {
      if (isMystery(it)) return;
      var unit = it.original_price != null ? it.original_price : (it.original_line_price != null ? it.original_line_price / it.quantity : it.final_price);
      var q = Array.isArray(qty) ? (qty[i] != null ? +qty[i] || 0 : it.quantity) : (qty && Object.prototype.hasOwnProperty.call(qty, it.key) ? +qty[it.key] || 0 : it.quantity);
      s += unit * q;
    });
    return Math.round(s);
  }
  function tierAt(sum) { var h = null; TIERS.forEach(function (tr) { if (sum >= tr.min) h = tr; }); return h; }
  function nextAt(sum) { return TIERS.filter(function (tr) { return sum < tr.min; })[0] || null; }
  function codesOn(c) { return (c.discount_codes || []).map(function (d) { return { code: String(d.code || '').toUpperCase(), on: !!d.applicable }; }); }
  // a working code that is not one of ours (typed by the shopper at checkout): never overwrite it
  function ownCode(c) { return codesOn(c).filter(function (d) { return d.on && !TIER_RE.test(d.code); })[0] || null; }
  // what the cart's discount field must become: 'ROYALnn', a list of codes to keep, '' (clear) or null (leave it alone)
  function wantDiscount(c, sum) {
    if (!c || !c.items || ownCode(c)) return null;
    var tr = OFFER ? tierAt(sum == null ? eligibleSum(c) : sum) : null, list = codesOn(c);
    // At a tier the tier code replaces the whole list ON PURPOSE: the ROYAL codes don't combine with other codes,
    // and a code that isn't working yet would block the tier discount.
    if (tr) return list.length === 1 && list[0].code === tr.c ? null : tr.c;
    // Below 500 QAR: take off only our ROYAL codes. A shopper's own code stays, even one that only works at
    // checkout (free delivery, a customer code), so Back from checkout never wipes it.
    if (!list.some(function (d) { return TIER_RE.test(d.code); })) return null;
    return list.filter(function (d) { return !TIER_RE.test(d.code); }).map(function (d) { return d.code; }).join(',');
  }
  // the discount Shopify really applied (the truth for every message)
  function appliedOn(c) {
    var tt = totals(c);
    if (!(tt.saved > 0)) return null;
    var d = null;
    c.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { if (!d && a.discount_application && a.discount_application.title) d = a.discount_application; }); });
    if (!d && c.cart_level_discount_applications && c.cart_level_discount_applications[0]) d = c.cart_level_discount_applications[0];
    if (!d) return null;
    var tr = tierByCode(d.title);
    return { code: String(d.title), tier: tr, p: tr ? tr.p : (d.value_type === 'percentage' ? Math.round(+d.value) : 0), saved: tt.saved, orig: tt.orig, now: tt.now };
  }
  // Shopify's /discount/CODE link leaves a discount_code cookie, and checkout then also tries that old code
  // ("ROYAL30 couldn't be used with your existing discounts") and writes it back to the cart. Drop ours only.
  function dropOldCodeCookie() {
    try {
      var m = /(?:^|;\s*)discount_code=([^;]*)/.exec(document.cookie || '');
      if (m && TIER_RE.test(decodeURIComponent(m[1]))) document.cookie = 'discount_code=; path=/; max-age=0; SameSite=Lax';
    } catch (e) {}
  }
  function ssGet(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  var sync = { sig: '', at: 0, failed: false };
  function syncCode(c) {
    dropOldCodeCookie();
    var want = wantDiscount(c);
    if (want === null) { sync.failed = false; return Promise.resolve(c); }
    var sig = want + '|' + eligibleSum(c) + '|' + codesOn(c).map(function (d) { return d.code; }).join(',');
    if (sig === sync.sig && Date.now() - sync.at < 30000) return Promise.resolve(c); // same cart already tried: no loop
    var rej = ssGet('rp-code-rejected');                                                // Shopify refused this exact change lately
    if (rej && rej.sig === sig && Date.now() - rej.at < 600000) return Promise.resolve(c);
    sync.sig = sig; sync.at = Date.now();
    return cartPost('cart/update.js', { discount: want }, true).then(function (n) {
      sync.failed = false; n._rpAsked = want;
      if (wantDiscount(n) === want) ssSet('rp-code-rejected', { sig: sig, at: Date.now() });  // e.g. the code was ended in admin
      return n;
    }, function () { sync.failed = true; return c; });
  }
  // fix the code, then check Shopify's answer once more (the guard in syncCode stops any loop).
  // n._rpCodeChanged: the cart's codes really changed (the bag page then reloads once).
  function codeSig(c) { return codesOn(c).map(function (d) { return d.code + (d.on ? '+' : '-'); }).join(',') + '|' + totals(c).now; }
  function settle(c) {
    return syncCode(c).then(function (n) {
      if (n === c) return n;
      // the bag changed while we asked (e.g. Add to bag landed first): ask again; if Shopify simply refused, don't
      var again = wantDiscount(n) === n._rpAsked ? Promise.resolve(n) : syncCode(n);
      return again.then(function (m) { m._rpCodeChanged = codeSig(m) !== codeSig(c); return m; });
    });
  }
  // body for any quantity change, with the code the NEW quantities will need
  function withCode(c, updatesByKey, body) {
    var want = wantDiscount(c, eligibleSum(c, updatesByKey));
    if (want !== null) body.discount = want;
    return body;
  }
  function checkoutPath() { return (shopAr && lang === 'ar' ? '/ar' : '') + '/checkout'; }
  function discountPath(code) { return (shopAr && lang === 'ar' ? '/ar' : '') + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(checkoutPath()); }
  // Checkout link: straight to checkout once the code is on the cart; /discount/ only when the shop was busy
  function checkoutHref(c) {
    if (!OFFER) return checkoutPath();
    var tr = ownCode(c) ? null : tierAt(eligibleSum(c));
    return tr && wantDiscount(c) !== null ? discountPath(tr.c) : checkoutPath();
  }
  // ---- display: one version for the bag drawer and the bag page ----
  function bdi(s) { return '<bdi>' + esc(s) + '</bdi>'; }
  // line TOTAL: original crossed out, price after the discount, and the % pill
  function linePriceHtml(it) {
    if (!(it.original_line_price > it.final_line_price)) return money(it.final_line_price);
    var a = (it.line_level_discount_allocations || [])[0], d = a && a.discount_application, tr = d && tierByCode(d.title);
    var p = tr ? tr.p : (d && d.value_type === 'percentage' ? Math.round(+d.value) : 0);
    return '<s class="rp-was">' + money(it.original_line_price) + '</s> <span class="rp-now">' + money(it.final_line_price) + '</span>' + (p ? ' <span class="rp-off">' + fill('offPill', { p: p }) + '</span>' : '');
  }
  // subtotal before (crossed out) and after, then "You save" (no minus sign: avoids bidi trouble in Arabic)
  function totalsHtml(c) {
    var tt = totals(c);
    return '<div class="rp-total"><span>' + t('subtotal') + '</span><span>' + (tt.saved > 0 ? '<s class="rp-was">' + money(tt.orig) + '</s> ' : '') + '<strong class="rp-now">' + money(tt.now) + '</strong></span></div>' +
      (tt.saved > 0 ? '<div class="rp-saved"><span>' + t('youSave') + '</span><span>' + moneyLess(tt.orig, tt.now) + '</span></div>' : '');
  }
  // Only ever ONE "applied" line, for the tier really on the cart. Never a lower-tier message.
  function offerHtml(c) {
    var app = appliedOn(c), own = ownCode(c), out = [];
    if (!OFFER) {   // offer switched off: only say what Shopify applied, if anything
      return app ? '<div class="offer-bar is-on" role="status" aria-live="polite"><p class="offer-applied">' + fill('offerOther', { c: bdi(app.code), x: moneyLess(app.orig, app.now) }) + '</p></div>' : '';
    }
    var sum = eligibleSum(c), have = tierAt(sum), next = nextAt(sum);
    var mys = c.items.some(isMystery);
    if (own) {
      if (app) out.push('<p class="offer-applied">' + fill('offerOther', { c: bdi(app.code), x: moneyLess(app.orig, app.now) }) + '</p>');
      next = null; have = null;                         // codes don't combine: no tier talk next to the shopper's own code
    } else if (have && app && app.tier && app.tier.c === have.c) {
      out.push('<p class="offer-applied">' + fill('offerOn', { c: bdi(have.c), p: have.p, x: moneyLess(app.orig, app.now) }) + (next ? '' : ' ' + t('offerBest')) + '</p>');
    } else if (have && sync.failed) {
      out.push('<p class="offer-applied">' + fill('offerHave', { c: bdi(have.c), p: have.p }) + '</p>'); // true: both Checkout buttons then go through /discount/
    } else if (have) {
      // tier reached but Shopify did not apply its code (offer paused or ended in admin, or Shopify counts the
      // total differently): promise nothing, no green bar, no "add more" line
      have = null; next = null;
    }
    if (next) out.push('<p>' + fill(have ? 'offerUp' : 'offerNext', { x: '<strong>' + money(next.min - sum) + '</strong>', p: next.p }) + (have ? '' : ' ' + t('offerAuto')) + '</p>');
    if (!out.length && !mys) return '';
    var track = !own && (have || next);
    var goal = next ? next.min : TIERS[TIERS.length - 1].min;
    var pct = next ? Math.max(4, Math.min(99, Math.floor(sum / goal * 100))) : 100;
    return '<div class="offer-bar' + (have ? ' is-on' : '') + '" role="status" aria-live="polite">' + out.join('') +
      (track ? '<div class="offer-track" aria-hidden="true"><span style="width:' + pct + '%"></span></div>' : '') +
      (mys ? '<p class="offer-note">' + t('offerMystery') + '</p>' : '') + '</div>';
  }
  function renderPageOffer() {
    document.querySelectorAll('[data-rp-offer]').forEach(function (el) { el.innerHTML = cart && cart.items.length ? offerHtml(cart) : ''; });
  }
  // Checkout: straight to checkout when the bag is known to be right; otherwise fix the code first (4 s at most)
  function goCheckout(e) {
    var a = e.currentTarget;
    e.preventDefault();
    if (a.getAttribute('aria-disabled') === 'true') return;   // double tap
    a.setAttribute('aria-disabled', 'true');
    var href = a.getAttribute('href') || checkoutPath(), done = false;
    var go = function (u) { if (done) return; done = true; location.href = u; };
    dropOldCodeCookie();
    // fast path only when no write happened since this copy of the bag was read
    if (cartFresh() && Date.now() - cartAt < 15000 && !sync.failed && wantDiscount(cart) === null) { go(checkoutPath()); return; }
    setTimeout(function () { go(href); }, 4000);
    cartGet().then(settle).then(function (c) { useCart(c); go(checkoutHref(c)); }, function () { go(href); });
  }
  var orphanTried = false;
  function renderCart() {
    renderPageOffer();
    if (cart && !orphanTried && orphans(cart).length) {
      orphanTried = true;   // once per page, so a busy shop (429) can't start a loop
      var up = {}; orphans(cart).forEach(function (x) { up[x.key] = 0; });
      setBusy(true);
      cartPost('cart/update.js', withCode(cart, up, { updates: up })).then(settle)
        .then(function (c) { useCart(c); if (onCartPage()) { location.reload(); return true; } }, noop)
        .then(function (reloading) { setBusy(false); if (!reloading) renderCart(); });
      return;
    }
    var count = document.getElementById('bagCount');
    if (cart && count) { count.hidden = !cart.item_count; count.textContent = cart.item_count; }
    var body = document.getElementById('bagBody'), ft = document.getElementById('bagFt');
    var co = document.getElementById('bagCo'), after = document.getElementById('bagAfter');
    if (!body || !cart) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="empty">' + t('bagEmpty') + '</p>';
      ft.innerHTML = '<a class="btn ghost" href="/collections/shop">' + t('continue') + '</a>';
      if (co) co.innerHTML = ''; if (after) after.innerHTML = '';
      localiseLinks(ft);
      return;
    }
    var GIFT = window.RPG && RPG.hasCard ? RPG : null;   // Theme settings > Gift card on: the card shows as a small card under its piece
    // the gift code only loads where it's needed (layout/theme.liquid); a card that arrived from another tab loads it now
    var gcfg = cfg.gift || {};
    if (!GIFT && gcfg.on && gcfg.js && !renderCart.gcLoading && cart.items.some(function (x) { return x.properties && x.properties['Gift card']; })) {
      renderCart.gcLoading = true;
      var sc = document.createElement('script'); sc.src = gcfg.js; sc.onload = function () { renderCart(); }; document.head.appendChild(sc);
    }
    // the card row goes under the piece AND its gift box (as in the approved design), so it waits for the piece's add-on lines
    var html = [], pending = null, pendingKey = null;
    cart.items.forEach(function (it, i) {
      var par = isChild(it) ? parentOf(it) : null;
      if (pending && !(par && par.key === pendingKey)) { html.push(pending); pending = null; }
      html.push(lineHtml(it, i));
      if (!isChild(it) && GIFT && GIFT.hasCard(it)) { pending = GIFT.bagRow(it, { fromCart: onCartPage() }); pendingKey = it.key; }
    });
    if (pending) html.push(pending);
    body.innerHTML = html.join('');
    function lineHtml(it, i) {
      var card = !!(GIFT && GIFT.hasCard(it));
      // values in <bdi>: an English value ("3-layer gift box") keeps its own order on the Arabic bag
      var props = it.properties ? Object.keys(it.properties).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k] && !(card && GIFT.isCardKey(k)) && (OFFER || (k !== 'Discount' && k !== 'الخصم')); }).map(function (k) { return esc(lang === 'ar' ? (PROP_AR[k] || k) : k) + ': ' + bdi(k === 'For' ? forTitle(it) : propVal(k, it.properties[k])); }).join('<br>') : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? bdi(it.variant_title) : '';   // "10 Years" keeps its order on the Arabic bag
      return '<div class="line' + (isChild(it) ? ' is-child' : '') + '">' + (it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="">' : '<span class="addon-ico" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24"><path d="M3 10h18v11H3zM2 6h20v4H2zM12 6v15M12 6c-2-4-7-4-6 0 1 2 6 0 6 0zm0 0c2-4 7-4 6 0-1 2-6 0-6 0z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg></span>') +
        '<div><div>' + esc(it.product_title) + '</div>' +
        '<div class="muted" style="font-size:15px">' + (variant ? variant + ' · ' : '') + linePriceHtml(it) + '</div>' +
        (props ? '<div class="line-props">' + props + '</div>' : '') +
        (isChild(it) && !(it.properties && it.properties.For) ? '<div class="line-props">' + esc(lang === 'ar' ? PROP_AR.For : 'For') + ': ' + bdi(forTitle(it)) + '</div>' : '') +
        (OFFER && isMystery(it) && !(it.properties && (it.properties['Discount'] || it.properties['الخصم'])) ? '<div class="line-props">' + esc(t('exclLine')) + '</div>' : '') +
        (isChild(it) ? '' : '<div class="qty"><button type="button" data-l="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="' + (lang === 'ar' ? 'إنقاص' : 'Decrease') + '">−</button><span style="min-width:22px;text-align:center">' + it.quantity + '</span><button type="button" data-l="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="' + (lang === 'ar' ? 'زيادة' : 'Increase') + '">+</button></div>') + '</div>' +
        '<button class="icon-btn" type="button" data-l="' + (i + 1) + '" data-q="0" aria-label="' + t('remove') + '"><svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.5"/></svg></button></div>';
    }
    if (GIFT) GIFT.fit(body);
    // order: lines, offer bar, subtotal before/after + You save + currency note, Checkout (stays at the bottom), Continue shopping, delivery note
    var sumH = offerHtml(cart) +
      '<div class="rp-sum">' + totalsHtml(cart) + '<p class="cx-note" data-rp-cx-note="bag" data-rp-pay="' + totals(cart).now + '" hidden></p></div>';
    var coH = '<a class="btn" data-rp-checkout href="' + esc(checkoutHref(cart)) + '">' + t('checkout') + '</a>';
    var afterH = '<button type="button" class="link" data-rp-continue>' + BACK_ARROW + '<span>' + t('continue') + '</span></button>' +
      '<p class="note" style="margin:0">' + t('deliveryNote') + '</p>';
    // layout/theme.liquid from 28 Oct has separate slots; an older layout has only #bagFt, so everything goes there
    if (co && after) { ft.innerHTML = sumH; co.innerHTML = coH; after.innerHTML = afterH; }
    else ft.innerHTML = sumH + coH + afterH;
    if (window.RPX && RPX.scan) RPX.scan(ft);
    var cb = (co || ft).querySelector('[data-rp-checkout]'); if (cb) cb.addEventListener('click', goCheckout);
    localiseLinks(body.parentNode);
    body.querySelectorAll('[data-l]').forEach(function (b) {
      b.disabled = busyN > 0;
      b.onclick = function () {
        var it = cart.items[+b.dataset.l - 1]; if (!it) return;
        setBusy(true);
        setQty(it, Math.max(0, +b.dataset.q))
          .then(function (c) { useCart(c); }, function () { showToast(t('busy')); })
          .then(function () { setBusy(false); renderCart(); });
      };
    });
  }
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.classList.add('on');
    clearTimeout(showToast._t); showToast._t = setTimeout(function () { toast.classList.remove('on'); }, 2200);
  }

  // ---------------- gift card on a bag line (rp-gift.js): save an edited card, or take the card off ----------------
  // info = { key, cid, variant, props } of the line as it was; the line is found again by key, else by its card
  // (the ROYAL code changes line keys). cardProps = the new card, or {} to take the card off.
  function putCard(info, cardProps) {
    info = info || {};
    return cartGet().then(function (c) {
      var it = RPG.findLine(c.items, info.key, info);
      if (!it) throw { gone: true };
      var p = {};
      Object.keys(it.properties || {}).forEach(function (k) { var v = it.properties[k]; if (!RPG.isCardKey(k) && v != null && v !== '') p[k] = v; });
      Object.keys(cardProps || {}).forEach(function (k) { p[k] = cardProps[k]; });
      // the new card can be the same as another line of this piece: Shopify then merges the two (see foldAddons)
      if (Object.keys(p).length) return cartPost('cart/change.js', { id: it.key, quantity: it.quantity, properties: p }).then(foldAddons);
      // Nothing else on the line: Shopify ignores an empty property list, and blank values would stay on the order.
      // So the piece goes back in clean: remove it, then add it again (with any add-on lines it had).
      var kids = c.items.filter(function (x) { return x.parent_relationship && x.parent_relationship.parent_key === it.key; });
      var back = [{ id: it.variant_id, quantity: it.quantity }].concat(kids.map(function (x) {
        var kp = {}; Object.keys(x.properties || {}).forEach(function (k) { if (x.properties[k] != null && x.properties[k] !== '') kp[k] = x.properties[k]; });
        kp._rp_pp = sig(JSON.stringify(p));
        return { id: x.variant_id, quantity: x.quantity, parent_id: it.variant_id, properties: kp };
      }));
      var ups = c.items.map(function (x) { return x === it || kids.indexOf(x) > -1 ? 0 : x.quantity; });
      return cartPost('cart/update.js', { updates: ups }).then(function () {
        return cartAdd(back).catch(function (e) {
          // put the line back as it was, so nothing is lost
          var undo = [{ id: it.variant_id, quantity: it.quantity, properties: it.properties }].concat(kids.map(function (x) { return { id: x.variant_id, quantity: x.quantity, parent_id: it.variant_id, properties: x.properties }; }));
          return cartAdd(undo).then(function () { throw e; }, function () { throw e; });
        });
      }).then(function () { return cartGet(); }).then(foldAddons);
    }).then(settle);
  }
  // the X on a card row (bag drawer and bag page): takes only the card off that piece
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gc-remove]'); if (!b || !window.RPG) return;
    var row = b.closest('[data-gc-key]'); if (!row) return;
    e.preventDefault();
    if (b.disabled) return;
    b.disabled = true; setBusy(true);
    var info = { key: row.getAttribute('data-gc-key'), cid: row.getAttribute('data-gc-cid') || '', variant: row.getAttribute('data-gc-variant') || '' };
    // the piece's details as the bag last showed them: if its key has changed since (a new ROYAL code), two copies
    // with the same card but different box names are told apart by them (RPG.findLine)
    var shown = cart && cart.items.filter(function (x) { return x.key === info.key; })[0];
    if (shown && shown.properties) info.props = shown.properties;
    putCard(info, {}).then(function (c) {
      useCart(c); showToast(RPG.t('removed'));
      if (onCartPage()) { location.reload(); return true; }
    }, function (x) { showToast(x && x.gone ? RPG.t('gone') : cartErr(x)); })
      .then(function (reloading) { setBusy(false); if (!reloading) { b.disabled = false; renderCart(); } });
  });

  // ---------------- product form ----------------
  document.querySelectorAll('[data-rp-product]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('script[data-rp-variants]').textContent);
    var form = root.querySelector('form');
    var idInput = form.querySelector('input[name=id]');
    var btn = form.querySelector('[data-add]');
    var priceEl = root.querySelector('[data-price]'), wasEl = root.querySelector('[data-was]');
    var cxNote = root.querySelector('[data-rp-cx-note]');
    var err = root.querySelector('[data-error]');
    function selected() {
      return data.options.map(function (o, i) {
        var c = form.querySelector('input[name="option' + (i + 1) + '"]:checked');
        return c ? c.value : null;
      });
    }
    // "Edit card" from the bag (rp-gift.js): the button saves the card on that bag line instead of adding a new one
    function editKey() { return window.RPG && RPG.editKey ? RPG.editKey(form) : null; }
    function update() {
      if (editKey()) { btn.disabled = false; btn.textContent = RPG.saveLabel(form); return; }
      var sel = selected();
      var v = null;
      if (!data.options.length) {
        v = data.variants[0];
      } else if (sel.every(function (x) { return x !== null; })) {
        v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      }
      // availability per option value (given other selections)
      data.options.forEach(function (o, i) {
        form.querySelectorAll('input[name="option' + (i + 1) + '"]').forEach(function (inp) {
          var ok = data.variants.some(function (x) {
            return x.available && x.options[i] === inp.value && x.options.every(function (ov, j) { return j === i || sel[j] === null || sel[j] === ov; });
          });
          inp.parentNode.classList.toggle('unavail', !ok);
        });
      });
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (wasEl) { wasEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
        // "Approximate price in SAR. You pay 349 QAR at checkout." follows the size picked
        if (cxNote && window.RPX) { cxNote.setAttribute('data-rp-pay', v.price); RPX.note(cxNote); }
        btn.disabled = !v.available;
        btn.textContent = v.available ? t('addToBag') : t('soldOut');
        if (history.replaceState && data.variants.length > 1) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
      } else {
        idInput.value = '';
        var anyAv = data.variants.some(function (x) { return x.available; });
        btn.disabled = !anyAv;
        btn.textContent = anyAv ? t('addToBag') : t('soldOut');
      }
    }
    form.addEventListener('change', update);
    document.addEventListener('rp:lang', update);
    update();
    // ---- add-on rows: the picked one is highlighted; an add-on with a name (the 3-layer box, Name embroidery) opens
    // its small field right under it. A closed field is never sent (another option was picked, or it was unticked).
    function addonPanel(inp) { return form.querySelector('[data-addon-x="' + inp.value + '"]'); }
    function addonErr(panel, msg) {
      var f = panel.querySelector('[data-addon-prop]'), e = panel.querySelector('[data-addon-err]');
      if (e) e.textContent = msg || '';
      if (f) { if (msg) f.setAttribute('aria-invalid', 'true'); else f.removeAttribute('aria-invalid'); }
      if (!msg && err && err.textContent === t('axEmbErr')) err.textContent = '';
    }
    // an empty name box follows the page (Chrome reads an empty dir="auto" box as left-to-right, which put the Arabic
    // placeholder and the cursor on the left); once there are letters they pick their own direction (same as rp-gift.js)
    function axDir(f) { f.setAttribute('dir', f.value ? 'auto' : (lang === 'ar' ? 'rtl' : 'ltr')); }
    // A name we print or embroider: letters of any language (Arabic, Latin...) with their marks, spaces, - ' ’ . and &.
    // Emoji and symbols are taken out as they are typed or pasted, with a short note, so what the shopper sees is
    // what goes on the order. Browsers without Unicode classes in RegExp simply keep what was typed.
    var AX_BAD = (function () { try { return new RegExp('[^\\p{L}\\p{M}\\s\'’.&-]|[\\uFE00-\\uFE0F\\u20E3\\u{E0100}-\\u{E01EF}]', 'gu'); } catch (x) { return null; } })();
    function axStrip(v) { return AX_BAD ? String(v).replace(AX_BAD, '') : String(v); }
    function axHint(panel, on) {
      var h = panel && panel.querySelector('[data-addon-hint]'); if (!h) return;
      clearTimeout(h._t); h.textContent = on ? t('axLetters') : '';
      if (on) h._t = setTimeout(function () { h.textContent = ''; }, 6000);
    }
    function axClean(f) {
      var v = f.value, c = axStrip(v);
      if (c === v) return false;
      // "Noor 👑 Al-Thani" -> "Noor Al-Thani", not two spaces where the emoji was
      var tidy = function (s) { return axStrip(s).replace(/\s{2,}/g, ' '); };
      var at = f.selectionStart == null ? v.length : f.selectionStart, keep = tidy(v.slice(0, at)).length;
      c = tidy(v);
      f.value = c;
      keep = Math.min(keep, c.length);
      try { f.setSelectionRange(keep, keep); } catch (x) {}
      return true;
    }
    function paintAddons() {
      form.querySelectorAll('input[data-addon]').forEach(function (inp) {
        var lb = inp.closest('label'), panel = addonPanel(inp);
        if (lb) lb.classList.toggle('is-on', inp.checked);
        if (!panel) return;
        if (lb) lb.classList.toggle('x-open', inp.checked);
        // a tick box says it opened the name field (aria-expanded is not allowed on a radio; there the field simply follows)
        if (inp.type === 'checkbox') inp.setAttribute('aria-expanded', inp.checked ? 'true' : 'false');
        panel.hidden = !inp.checked;
        if (!inp.checked) { addonErr(panel, ''); axHint(panel, false); }
      });
      form.querySelectorAll('[data-addon-prop]').forEach(axDir);
    }
    // "Please choose: Gift wrapping" goes as soon as a wrapping option is picked (it used to stay until the next Add to bag)
    function reqAddonOk() {
      var g = form.querySelector('[data-addon-required]'), lg = g && g.querySelector('legend');
      if (err && lg && g.querySelector('input[data-addon]:checked') && err.textContent === t('choose') + ': ' + lg.textContent) err.textContent = '';
    }
    form.addEventListener('change', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-addon')) { paintAddons(); reqAddonOk(); } });
    form.addEventListener('input', function (e) {   // a name typed in: emoji / symbols out, its error goes straight away
      var f = e.target, panel = f && f.closest && f.hasAttribute('data-addon-prop') ? f.closest('[data-addon-x]') : null;
      if (!panel) return;
      if (!e.isComposing && axClean(f)) axHint(panel, true);
      axDir(f);
      if (f.value.trim()) addonErr(panel, '');
    });
    form.addEventListener('compositionend', function (e) {
      var f = e.target, panel = f && f.closest && f.hasAttribute && f.hasAttribute('data-addon-prop') ? f.closest('[data-addon-x]') : null;
      if (panel && axClean(f)) { axHint(panel, true); axDir(f); }
    });
    document.addEventListener('rp:lang', paintAddons);
    paintAddons();
    // the names typed for the picked add-ons, by add-on: { variantId: { 'Name on box': 'Maryam' } }.
    // A required one left empty gives { error } and puts the cursor in its field.
    function addonExtras(addons) {
      var out = {}, bad = null;
      Array.prototype.forEach.call(addons, function (a) {
        var panel = addonPanel(a); if (!panel) return;
        panel.querySelectorAll('[data-addon-prop]').forEach(function (f) {
          var v = axStrip(f.value).trim().replace(/\s+/g, ' ');
          if (!v && f.hasAttribute('data-addon-req')) { addonErr(panel, t('axEmbErr')); if (!bad) bad = f; return; }
          if (v) (out[a.value] = out[a.value] || {})[f.getAttribute('data-addon-prop')] = v;
        });
      });
      if (bad) { bad.focus(); return { error: t('axEmbErr') }; }
      return { props: out };
    }
    // Save card: keep every other detail of the line (size note, name, add-ons...), swap only the card.
    // With the card switched off, the card is taken off the line (Remove card).
    function saveCard(info, cardProps) {
      var removing = !Object.keys(cardProps || {}).length;
      btn.disabled = true;
      putCard(info, cardProps).then(function (c) {
        useCart(c);
        var back = RPG.editFromCart(form);
        RPG.endEdit(form, true);
        showToast(RPG.t(removing ? 'removed' : 'saved'));
        if (back) { location.href = (shopAr && lang === 'ar' ? '/ar' : '') + '/cart'; return; }
        openCart(true);
      }).catch(function (x) {
        if (err) err.textContent = x && x.gone ? RPG.t('gone') : cartErr(x);
      }).then(function () { btn.disabled = false; update(); });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (err) err.textContent = '';
      var gift = window.RPG && RPG.collect ? RPG.collect(form) : null;   // null: no gift box on this page
      if (gift && gift.error) { if (err) err.textContent = gift.error; return; }
      var ek = editKey();
      if (ek) { saveCard(RPG.editInfo(form), gift ? gift.props : {}); return; }
      if (!idInput.value) {
        var missing = data.options.filter(function (o, i) { return !form.querySelector('input[name="option' + (i + 1) + '"]:checked'); })[0];
        if (err) err.textContent = t('choose') + (missing ? ': ' + missing : '');
        return;
      }
      var reqField = Array.prototype.filter.call(form.querySelectorAll('[data-required]'), function (f) { return !f.value; })[0];
      if (reqField) { if (err) err.textContent = t('choose') + ': ' + (form.querySelector('label[for="' + reqField.id + '"]') || {}).textContent; reqField.focus(); return; }
      var reqAddon = form.querySelector('[data-addon-required]');
      if (reqAddon && !reqAddon.querySelector('input[data-addon]:checked')) { if (err) err.textContent = t('choose') + ': ' + reqAddon.querySelector('legend').textContent; return; }
      var ax = addonExtras(form.querySelectorAll('input[data-addon]:checked'));
      if (ax.error) { if (err) err.textContent = ax.error; return; }
      var props = {};
      form.querySelectorAll('[data-prop]').forEach(function (f) { if (f.value.trim()) props[f.getAttribute('data-prop')] = f.value.trim(); });
      if (OFFER && root.hasAttribute('data-rp-excluded')) props[t('offerExclKey')] = t('offerExclVal');
      if (gift && gift.props) Object.keys(gift.props).forEach(function (k) { props[k] = gift.props[k]; });   // a different card = a different bag line
      var addons = form.querySelectorAll('input[data-addon]:checked'), items = [];
      var selV = data.variants.filter(function (x) { return String(x.id) === String(idInput.value); })[0];
      var forName = data.title + (selV && selV.options && selV.options.length ? ' · ' + selV.options.join(' / ') : '');
      if (addons.length) props['With'] = Array.prototype.map.call(addons, function (a) { var s = a.closest('label') && a.closest('label').querySelector('[data-en]'); return s ? s.getAttribute('data-en') : ''; }).filter(Boolean).join(', ');
      // _rp_ax (hidden): the add-on names in short. Two copies of the same set with different names on their boxes are
      // then two pieces, each with its own box line (without it Shopify would join the pieces into one line ×2).
      if (Object.keys(ax.props).length) props._rp_ax = sig(JSON.stringify(ax.props));
      items.push({ id: +idInput.value, quantity: 1, properties: props });
      // _rp_pp (hidden): the piece's own details in short, so the add-on lines of two differently filled copies of the
      // same piece are two different lines (with the same line key, + / − / X in the bag could change the other piece's box)
      var pp = sig(JSON.stringify(props));
      // the add-on's own line: For, then its name ("Name on box" / "Name to embroider") so the team sees it next to the box
      addons.forEach(function (a) {
        var ap = { 'For': forName }, x = ax.props[a.value] || {};
        Object.keys(x).forEach(function (k) { ap[k] = x[k]; });
        ap._rp_pp = pp;
        items.push({ id: +a.value, quantity: 1, parent_id: +idInput.value, properties: ap });
      });
      btn.disabled = true;
      // same queue as every other cart request, then a NEW read of the bag (never the one started at page load)
      cartAdd(items)
        .then(function () { showToast(t('added')); openCart(true); })
        .catch(function (x) { if (err) err.textContent = cartErr(x); })
        .then(function () { btn.disabled = false; update(); });
    });
    // gallery
    var main = root.querySelector('[data-main-img]');
    root.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.getAttribute('data-thumb'); main.srcset = '';
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });
  });

  // ---------------- reveal ----------------
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function reveal(root) { (root || document).querySelectorAll('.rv:not(.in)').forEach(function (el) { io ? io.observe(el) : el.classList.add('in'); }); }

  // ---------------- cart page: add-ons follow their piece; quantities and the tier code change together ----------------
  var cartForm = document.querySelector('.cart-page form');
  if (cartForm) {
    var lines = Array.prototype.slice.call(cartForm.querySelectorAll('.line[data-key]'));
    var kids = function (k) { return k ? lines.filter(function (l) { return l.dataset.rpParent === k; }) : []; };
    var subs = cartForm.querySelectorAll('[type=submit]'), lastSub = null;   // e.submitter is missing in older Safari
    Array.prototype.forEach.call(subs, function (b) { b.addEventListener('click', function () { lastSub = b; }); });
    lines.forEach(function (l) {
      var rm = l.querySelector('[data-rp-remove]');
      if (rm) rm.addEventListener('click', function (e) {
        e.preventDefault();
        var gone = [l].concat(kids(l.dataset.rpKey));
        var u = {}; gone.forEach(function (x) { u[x.dataset.key] = 0; });
        // by position when the bag has been read (two gift boxes can share a key), by key otherwise
        var body = { updates: u };
        if (cart && cart.items.length === lines.length) body = withCode(cart, lines.map(function (x, i) { return gone.indexOf(x) > -1 ? 0 : cart.items[i].quantity; }), { updates: lines.map(function (x, i) { return gone.indexOf(x) > -1 ? 0 : cart.items[i].quantity; }) });
        else if (cart) body = withCode(cart, u, body);
        // busy shop: fall back to Shopify's own remove link (item.url_to_remove)
        cartPost('cart/update.js', body).then(settle)
          .then(function () { location.reload(); }, function () { location.href = rm.getAttribute('href'); });
      });
    });
    cartForm.addEventListener('submit', function (e) {
      // add-ons follow their piece, counted per add-on (data-rp-variant): two gift-box lines under one merged piece
      // are folded into the first, so there are never more gift boxes than pieces (same rule as setQty)
      lines.forEach(function (l) {
        var q = l.querySelector('[data-rp-qty]'); if (!q || !l.dataset.rpKey) return;
        var by = {};
        kids(l.dataset.rpKey).forEach(function (c) { var cq = c.querySelector('[data-rp-qty]'); if (!cq) return; var v = c.dataset.rpVariant || c.dataset.key; (by[v] = by[v] || []).push(cq); });
        Object.keys(by).forEach(function (v) {
          var g = by[v], tot = 0; g.forEach(function (cq) { tot += +cq.value || 0; });
          var want = tot >= +(q.defaultValue || 0) ? +q.value || 0 : Math.min(tot, +q.value || 0);
          g.forEach(function (cq, j) { cq.value = j ? 0 : want; });
        });
      });
      if (!cart) return;                     // bag not read yet: the normal form post does the job
      var sub = e.submitter || lastSub, isCo = !!(sub && sub.name === 'checkout');
      e.preventDefault();
      var ups = Array.prototype.map.call(cartForm.querySelectorAll('[name="updates[]"]'), function (i) { return +i.value || 0; });
      // Liquid and cart.js list the lines in the same order; syncCode corrects a wrong guess
      var byKey = {}; cart.items.forEach(function (it, i) { if (i < ups.length) byKey[it.key] = ups[i]; });
      var noteEl = cartForm.querySelector('[name="note"]');
      Array.prototype.forEach.call(subs, function (b) { b.disabled = true; });
      cartPost('cart/update.js', withCode(cart, byKey, { updates: ups, note: noteEl ? noteEl.value : '' }))
        .then(settle)
        .then(function (c) { if (isCo) location.href = checkoutHref(c); else location.reload(); })
        .catch(function () {
          // Shop busy (429): Shopify's own form post takes over. It must carry the tier code too, so the
          // "Code ROYALnn is applied at checkout" message stays true here as well as in the bag drawer.
          var want = wantDiscount(cart, eligibleSum(cart, byKey));
          var same = cart.items.every(function (it) { return !Object.prototype.hasOwnProperty.call(byKey, it.key) || byKey[it.key] === it.quantity; }) &&
            (!noteEl || noteEl.value === noteEl.defaultValue);
          if (isCo && want && TIER_RE.test(want) && same) { location.href = discountPath(want); return; }   // nothing else to save: apply the code on the way to checkout
          var add = function (n, v) { var h = document.createElement('input'); h.type = 'hidden'; h.name = n; h.value = v; cartForm.appendChild(h); };
          if (want !== null) add('discount', want);
          if (isCo) add('checkout', '1');
          cartForm.submit();
        });
    });
  }

  window.RP = { t: t, lang: function () { return lang; }, money: money, moneyQ: moneyQ, reveal: reveal, openCart: openCart, refreshCart: refreshCart, applyLang: applyLang, WA: WA };
  applyLang();
  reveal();
  var bc = document.getElementById('bagCount');
  if (!bc || !bc.hidden || document.querySelector('.cart-page')) refreshCart();
  document.dispatchEvent(new CustomEvent('rp:lang'));
})();
